/* EVENTS */
export const CREATE_COMPANY = "CREATE_COMPANY";
export const COMPANY_SUCCESS = "COMPANY_SUCCESS";
export const COMPANY_ERROR = "COMPANY_ERROR";
export const UPDATE_COMPANY = "UPDATE_COMPANY";